import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskScreenType } from '../types/assign-kiosk-types';

export interface GetMachineModelResult {
  screenType: KioskScreenType;
  hasError: boolean;
  errorMessage?: string;
}

export class GetMachineModelUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string): Promise<GetMachineModelResult> {
    try {
      const response = await this.repository.getMachineModel(machineId);
      // API may return a plain string or an object — handle both
      const machineModel = typeof response === 'string' ? response : response.machineModel;
      const screenType = this.repository.resolveScreenType(machineModel);
      return { screenType, hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load machine model';
      return { screenType: 'FALLBACK', hasError: true, errorMessage };
    }
  }
}
